<template>
  <!-- -->
  <div class="member-card" :style="{'--text-color': settingData.textColor, '--text-background-color': settingData.textBackground}">
    <div>
      <div class="name-1">202606131054112</div>
      <div class="name-2">超级SVIP会员</div>
    </div>
    <div>
      <div class="name-1">积分</div>
      <div class="name-2">9,999</div>
    </div>
    <div>
      <yq-icon name="element-ui_arrow-right" />
    </div>
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
import {Calendar} from "@element-plus/icons-vue";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    Calendar,
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.member-card {
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  :nth-child(1){
    flex: 1;
  }
  :nth-child(2){
    margin-right: 30px;
  }
  :nth-child(3){
    color: var(--text-background-color);
  }
  .name-1{
    font-size: 24px;
    color: var(--text-background-color);
  }
  .name-2{
    font-size: 32px;
    font-weight: 500;
    margin-top: 10px;
    color: var(--text-color);
  }
}
</style>